<template>
  <div class="coordinate-axis-y">
    <div class="dashed-line"></div>
    <div class="top-triangle"></div>
    <div class="bottom-triangle"></div>
    <div class="label top-label">High Cost</div>
    <div class="label bottom-label">Low Cost</div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.coordinate-axis-y {
  position: relative;
  width: 50px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 0;
  box-sizing: border-box;
  flex-direction: column;
}

.dashed-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 1px;
  border-left: 2px dashed #ccc;
  z-index: 1;
  transform: translateX(-50%);
}

.top-triangle {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #868897;
  z-index: 1000;
}

.bottom-triangle {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #868897;
  z-index: 1000;
}

.label {
  font-size: 14px;
  font-family: Arial, sans-serif;
  z-index: 2;
  white-space: nowrap;
}

.top-label {
  top: -40px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.bottom-label {
  bottom: -40px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
